import { useState } from 'react';

/**
 * Masked-secret reveal control.
 * - Default: shows fixed-width placeholder dots, plus a Reveal button.
 * - On reveal: shows the raw value + Copy + Hide.
 *
 * Component test (`MaskedSecret.test.tsx`) asserts the value is NOT in the
 * DOM until the reveal click. The placeholder is rendered as a separate
 * <span> with a distinguishable test id.
 */
export function MaskedSecret({
  value,
  label,
}: {
  value: string;
  label?: string;
}) {
  const [revealed, setRevealed] = useState(false);
  return (
    <div className="flex items-center gap-2">
      {label ? <span className="text-sm text-slate-600">{label}</span> : null}
      {revealed ? (
        <code
          data-testid="masked-secret-value"
          className="rounded bg-slate-100 px-2 py-1 font-mono text-xs"
        >
          {value}
        </code>
      ) : (
        <span
          data-testid="masked-secret-placeholder"
          aria-hidden
          className="font-mono text-xs tracking-widest text-slate-400"
        >
          ••••••••••••
        </span>
      )}
      <button
        type="button"
        className="btn"
        onClick={() => setRevealed((v) => !v)}
      >
        {revealed ? 'Hide' : 'Reveal'}
      </button>
      {revealed ? (
        <button
          type="button"
          className="btn"
          onClick={() => void navigator.clipboard?.writeText(value)}
        >
          Copy
        </button>
      ) : null}
    </div>
  );
}
